import { format } from "date-fns";
import { DATE_FORMATS } from "./enum";

export function firebaseTimestampToDate(value: any): Date | null | string {
  if (!value) return null;

  if (typeof value.toDate === "function") {
    return value.toDate();
  }

  const seconds = value.seconds ?? value._seconds;
  const nanoseconds = value.nanoseconds ?? value._nanoseconds;

  if (typeof seconds === "number") {
    return new Date(seconds * 1000 + Math.floor((nanoseconds ?? 0) / 1e6));
  }

  const date = new Date(value);
  if (!isNaN(date.getTime())) {
    return date;
  }

  return null;
}

export const formatDate = (
  date: Date | undefined | string | null,
  dateFormat = DATE_FORMATS.SHORT_YEAR_MONTH_DATE
) => {
  if (!date) return undefined;
  try {
    const value = typeof date === "string" ? new Date(date) : date;
    return format(value, dateFormat);
  } catch {
    return undefined;
  }
};
